import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';

import { FETCH_CLIMB_DIFFICULTIES, FETCH_CLIMB_DIFFICULTIES_SUCCESS } from '../actions/dailySummaryActions.js';
import { webApi } from '../config/axios';

export function* fetchRouteDifficultiesSaga(action) {
    try {
        const response = yield call(webApi.get, `/web-data/climb-difficulty/climb-difficulty-master.json`);

        yield put({
            type: FETCH_CLIMB_DIFFICULTIES_SUCCESS,
            indoorClimbDifficulty: response.data
        });
    } catch (e) {
        // Handling Error
    }
}

export const climbDifficulties = [takeEvery(FETCH_CLIMB_DIFFICULTIES, fetchRouteDifficultiesSaga)];
